var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBellIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7615 9.53894L12.3985 8.1812V6.38258C12.397 5.13961 11.9328 3.94137 11.0958 3.01956C10.2588 2.09775 9.1084 1.51784 7.86707 1.39198V0.36377H6.86007V1.39198C5.61874 1.51784 4.46834 2.09775 3.63134 3.01956C2.79433 3.94137 2.33017 5.13961 2.3286 6.38258V8.1812L0.96564 9.53894C0.871209 9.63298 0.818144 9.76054 0.818115 9.89355V11.3983C0.818115 11.5313 0.871162 11.6589 0.965586 11.7529C1.06001 11.847 1.18808 11.8998 1.32161 11.8998H4.84609V12.4014C4.84609 13.0665 5.11132 13.7044 5.58344 14.1747C6.05556 14.645 6.69589 14.9092 7.36357 14.9092C8.03125 14.9092 8.67158 14.645 9.1437 14.1747C9.61582 13.7044 9.88105 13.0665 9.88105 12.4014V11.8998H13.4055C13.5391 11.8998 13.6671 11.847 13.7616 11.7529C13.856 11.6589 13.909 11.5313 13.909 11.3983V9.89355C13.909 9.76054 13.8559 9.63298 13.7615 9.53894ZM8.87406 12.4014C8.87406 12.8005 8.71492 13.1832 8.43165 13.4654C8.14838 13.7476 7.76418 13.9061 7.36357 13.9061C6.96296 13.9061 6.57876 13.7476 6.29549 13.4654C6.01222 13.1832 5.85308 12.8005 5.85308 12.4014V11.8998H8.87406V12.4014Z",
    fill: "#1773BC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellIcon);
export default __webpack_public_path__ + "static/media/BellIcon.e97a8f1478d5535fd77ce1cf80c975a9.svg";
export { ForwardRef as ReactComponent };